import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import IconButton from '@components/Buttons/IconButton'

interface CaptionsCTAButtonProps {
  captionsAvailable: boolean
  captionsEnabled: boolean
  onCaptionsButtonClick: () => void
}

const StyledIconButton = styled(IconButton)<{ disabled: boolean }>`
  ${({
    disabled,
    theme: {
      colors: { staticBlack },
      utils: { opacity },
    },
  }) => css`
    border-radius: 50%;
    background: ${opacity(staticBlack, '80')};

    opacity: ${disabled ? '0.2' : 1};
    pointer-events: ${disabled ? 'none' : 'all'};
  `}
`

const CaptionsCTAButton: FunctionComponent<CaptionsCTAButtonProps> = ({
  captionsAvailable,
  captionsEnabled,
  onCaptionsButtonClick,
}) => {
  const theme = useTheme()

  return (
    <StyledIconButton
      ariaLabel="Volume"
      buttonSize={40}
      onClick={onCaptionsButtonClick}
      disabled={!captionsAvailable}
      iconName={
        captionsAvailable && captionsEnabled
          ? 'subtitles-solid'
          : 'subtitles-slash-solid'
      }
      iconSize={20}
      iconColor={theme.colors.staticWhite}
    />
  )
}

export default CaptionsCTAButton
